import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import type { Bonus } from "../data/bonuses";
interface BonusCardProps {
  bonus: Bonus;
}
export function BonusCard({
  bonus
}: BonusCardProps) {
  const shouldReduceMotion = Boolean(useReducedMotion());
  return <motion.article initial={shouldReduceMotion ? false : {
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.18
  }} transition={{
    duration: 0.55,
    ease: [0.22, 1, 0.36, 1]
  }} className="group relative overflow-hidden rounded-[22px] border border-[#30343A] bg-[#141922] p-5 shadow-[0_22px_60px_rgba(0,0,0,0.24)] transition-[transform,border-color,box-shadow] duration-300 ease-out motion-safe:hover:-translate-y-0.5 hover:border-[#F2B84B]/30 hover:shadow-[0_26px_66px_rgba(0,0,0,0.32),0_0_28px_rgba(242,184,75,0.045)] sm:p-6" data-id="element-7" data-mp="2x4qiq0kiu4wt">
      <div className="grid items-center gap-5 sm:grid-cols-[150px_1fr] lg:grid-cols-[168px_1fr]" data-id="element-8" data-mp="1lpbjsr8r52z2">
        <div className="mx-auto aspect-square w-full max-w-[210px] overflow-hidden rounded-2xl bg-[#141922] sm:max-w-none" data-id="element-9" data-mp="1x1v70ucofix0">
          <img src={bonus.imageUrl} alt={`Mockup de ${bonus.title}`} className="h-full w-full object-cover transition-transform duration-500 ease-out motion-safe:group-hover:scale-[1.025]" loading="lazy" decoding="async" data-id="element-10" data-mp="1s2s177ovh8nz" />
        </div>

        <div className="min-w-0" data-id="element-11" data-mp="1df6wxag9h3eh">
          <p className="font-mono text-[11px] font-semibold tracking-[0.18em] text-[#F2B84B]" data-id="element-12" data-mp="1dc18lxfgi5jt">
            {bonus.number}
          </p>
          <h3 className="mt-2 text-xl font-bold leading-tight tracking-[-0.025em] text-[#F8F8F6] sm:text-[21px]" data-id="element-13" data-mp="14d7ecdpllr9f">
            {bonus.title}
          </h3>
          <p className="mt-3 text-sm leading-6 text-[#B7BBC0] sm:text-[15px]" data-id="element-14" data-mp="zg7a88cb6yky">
            {bonus.description}
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3" data-id="element-15" data-mp="2yp49ohr5vh9r">
            <span className="font-mono text-xs text-[#8E959C] line-through decoration-[#8E959C]/80 sm:text-sm" data-id="element-16" data-mp="2tsx78yxz4nwk">
              Valor: $12.900
            </span>
            <span className="rounded-full border border-[#F2B84B]/50 bg-[#F2B84B] px-3 py-1 text-[11px] font-extrabold tracking-[0.08em] text-[#101010] shadow-[0_0_18px_rgba(242,184,75,0.12)]" data-id="element-17" data-mp="wug88126971s">
              GRATIS
            </span>
          </div>
        </div>
      </div>
    </motion.article>;
}